export default __webpack_public_path__ + "static/media/lock.3f453df2.png";